import { useEffect } from "react";

const DEFAULT_IMAGE =
  "https://images.pexels.com/photos/3011575/pexels-photo-3011575.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Seo({ title, description, path = "/", image = DEFAULT_IMAGE }) {
  useEffect(() => {
    if (title) document.title = title;

    const set = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [key, val] = selector.replace("meta[", "").replace("]", "").split("=");
        el.setAttribute(key, val.replace(/["']/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      set('meta[name="description"]', "content", description);
      set('meta[property="og:description"]', "content", description);
      set('meta[name="twitter:description"]', "content", description);
    }
    if (title) {
      set('meta[property="og:title"]', "content", title);
      set('meta[name="twitter:title"]', "content", title);
    }
    const url = `https://thehmservices.com${path}`;
    set('meta[property="og:url"]', "content", url);
    set('meta[property="og:image"]', "content", image);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, path, image]);

  return null;
}
